export const SET_WEBSITE_CONTACT_FILTERS = 'SET_WEBSITE_CONTACT_FILTERS';
export const setWebContactFilters = (filterData: any) => ({
  type: SET_WEBSITE_CONTACT_FILTERS,
  payload: filterData,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const webContactFilterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_WEBSITE_CONTACT_FILTERS:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
export default webContactFilterReducer;
